import { ErrorHandler, Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {
  private readonly router = inject(Router);

  handleError(error: any): void {
    // Log the error for debugging
    console.error('Global error handler:', error);

    // Check if it's a network-related error
    const isNetworkError = 
      error?.message?.toLowerCase().includes('network') ||
      error?.message?.toLowerCase().includes('failed to fetch') ||
      error?.message?.toLowerCase().includes('internet') ||
      error?.name === 'NetworkError' ||
      (error?.status === 0);

    // Check if it's a critical error that should show the error page
    const isCriticalError = 
      isNetworkError ||
      error?.status >= 500 ||
      error?.name === 'ChunkLoadError' || // Failed to load lazy-loaded chunks
      error?.message?.toLowerCase().includes('loading chunk');

    if (isCriticalError) {
      // Navigate to error page
      this.router.navigate(['/error'], {
        state: { error: error }
      }).catch(() => {
        // If navigation fails, try to reload the page
        window.location.href = '/error';
      });
    }
  }
}


